import { useSearchContext } from "../../contexts";
import { useTranslation } from "react-i18next";
import { SourceChooser } from "../SourceChooser";
import { DropdownFilter } from "../../../../components/Filters/DropdownFilter";

interface SourceChooserDropdownProps {
  onOpenChange?: (isOpen: boolean) => void;
}

export const SourceChooserDropdown: React.FC<SourceChooserDropdownProps> = ({ onOpenChange }) => {
  const { state } = useSearchContext();
  const { t } = useTranslation();
  return (
    <DropdownFilter
      title={t("Actors")}
      counter={state.draftFilters.sources.value.length}
      isExclude ={state.draftFilters.sources.exclude}
      onOpenChange={onOpenChange}
    >
      <SourceChooser />
    </DropdownFilter>
  )
};
